// eslint-disable-next-line prettier/prettier
import Vue from 'vue'
import Vuex from 'vuex'
import global from '@/views/globalStore'
import authentication from './authenticationStore'
import mine from '@/views/mine/mineStore'
import home from '@/views/home/homeStore'
import contract from '@/views/contract/contractStore'
import survey from './surveyStore'
import jdjrSurvey from './jdjrSurveyStore'

import getters from './getters'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    global,
    authentication,
    mine,
    home,
    survey,
    jdjrSurvey,
    contract
  },
  getters,
  strict: process.env.NODE_ENV !== 'production' // 在发布环境下禁用严格模式
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js